class ProductAccessories extends HTMLElement {
  constructor() {
    super();

    this.currentText = this.querySelector('.accessories-products__progress .current');
    this.needText = this.querySelector('.accessories-products__progress .need');
    this.maxCount = Number(this.dataset.fastShippingCount);
    this.accessories = this.querySelectorAll('product-info');
    this.currentVariant = JSON.parse(this.dataset.currentVariant);
    this.discountLabel = document.querySelector('.product-single__box__block--discount_label .save');

    this.addSelectEventListeners();
    this.addQuantityEventListeners();

    this.addCheckboxListener();

    document.addEventListener('venue:variant:updated', this.updateVariantPrice.bind(this));

    document.body.addEventListener('showCongratulationsPopup', () => {
      theme.mfpOpen('congratulations');
    });
  }

  addSelectEventListeners() {
    const containerSelect = this.querySelectorAll('.product-complementary__select');

    containerSelect.forEach((select) => {
      select.addEventListener('change', function (e) {
        const complementaryProductItem = e.currentTarget.closest('.complementary-products__item');
        const { price, comparedPrice, image, parent } = e.currentTarget.options[select.selectedIndex].dataset;
        const imageHighRes = image ? image.replace('100', '1440') : null;
        let zoomImg = document.querySelector(`.complementary-products-zoom-images [data-id="${parent}"] img`);
        const itemImageEl = complementaryProductItem.querySelector('.product-complementary__image');

        if (!complementaryProductItem) return;

        if (complementaryProductItem.querySelector('.product-complementary__price--original')) {
          complementaryProductItem.querySelector('.product-complementary__price--original').innerHTML = price;
        }
        if (complementaryProductItem.querySelector('.product-complementary__price--compared')) {
          complementaryProductItem.querySelector('.product-complementary__price--compared').innerHTML = comparedPrice;
        }

        if (complementaryProductItem.querySelector('.product-complementary__image')) {
          itemImageEl.src = image ? image : itemImageEl.dataset.defaultImage;
        }

        if (zoomImg) {
          zoomImg.src = image ? image : itemImageEl.dataset.defaultImage;
          zoomImg.srcset = imageHighRes ? imageHighRes : itemImageEl.dataset.defaultImage;
        }
      });
    });
  }

  changeProgressbar(increment) {
    const activeEl = this.querySelectorAll('.progressbar li.active');
    let currentNumber = Number(this.currentText.innerHTML);

    if (increment) {
      if (currentNumber < this.maxCount) {
        this.currentText.innerHTML = ++currentNumber;
        this.needText.innerHTML = this.maxCount - currentNumber;
      }
      this.querySelector('.progressbar li:not(.active)')?.classList.add('active');
    } else {
      if (currentNumber > 0) {
        this.currentText.innerHTML = --currentNumber;
        this.needText.innerHTML = this.maxCount - currentNumber;
      }
      activeEl[activeEl.length - 1]?.classList.remove('active');
    }

    this.dataset.showPopup = currentNumber == this.maxCount;
  }

  addQuantityEventListeners() {
    this.addEventListener('click', (e) => {
      if (e.target.type == 'button' && e.target.classList.contains('product-add__quantity-btn')) {
        this.onQuantityChange(e);
      }
    });
  }

  onQuantityChange(e) {
    const quantityInputEl = e.target
      .closest('.product-add__quantity-wrap')
      ?.querySelector('.product-add__quantity-input');
    let updatedQuantityValue = Number(quantityInputEl.value);

    if (e.target.classList.contains('decrease')) {
      updatedQuantityValue--;
    } else if (e.target.classList.contains('increase')) {
      updatedQuantityValue++;
    }

    if (updatedQuantityValue === 0) {
      const checkboxEl = e.target.closest('.product-add__checkbox-wrap')?.querySelector('.product-add__checkbox');

      if (checkboxEl) checkboxEl.checked = false;
    } else if (e.target != quantityInputEl) {
      quantityInputEl.value = updatedQuantityValue;
    }

    this.updateTotalPrice();
  }

  updateTotalPrice() {
    let totalPrice = 0;
    let preorderPrice = 0;
    this.accessories.forEach((accessory) => {
      const quantityInput =
        accessory.querySelector(
          '.product-add__checkbox:checked~.product-add__quantity-wrap .product-add__quantity-input'
        )?.value || 0;
        
        totalPrice += Number(quantityInput) * accessory.dataset.price || 0;
        preorderPrice += Number(quantityInput) * accessory.dataset.preorderPrice || 0;
      });
      
    this.dataset.totalPrice = totalPrice;
    this.dataset.preorderPrice = preorderPrice;
    this.updateVariantPrice();
  }

  updateVariantPrice(e) {
    if (e?.detail?.variant) {
      this.currentVariant = e.detail.variant;
    }

    if (!this.currentVariant) {
      return;
    }
    
    if (!this.hasAttribute('data-total-price') && e) {
      return;
    }

    const totalPrice = Number(this.dataset.totalPrice) || 0;
    const preorderPrice = Number(this.dataset.preorderPrice) || 0;    
    
    const mainProductInfo = document.querySelector('product-info[id*="ProductInfo"]') || 
                           document.querySelector('product-info[data-section*="quickadd"]');
    
    if (!mainProductInfo) return;
    
    const priceEls = mainProductInfo.querySelectorAll('.js-product-price-number .money');
    const compareAtPriceEls = mainProductInfo.querySelectorAll('.js-product-price-compare .money');
    
    const stickyPriceEls = document.querySelectorAll('.stickyCart .selectedOpt .js-product-price-number .money');
    const stickyCompareAtPriceEls = document.querySelectorAll('.stickyCart .selectedOpt .js-product-price-compare .money');
    
    const earlyBirdPriceEls = mainProductInfo.querySelectorAll('.js-early-bird-product-price-number');
    const compareAtPriceEarlyBirdEls = mainProductInfo.querySelectorAll('.js-early-bird-product-price-number .earlybird__price--strikethrough');

    earlyBirdPriceEls.forEach(el => el.childNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.includes('$')) {
        node.textContent = Shopify.formatMoney(this.currentVariant.selling_plan_price + preorderPrice, theme.money_format).replace(/<[^>]+>/g, '');;
      }
    }));

    compareAtPriceEarlyBirdEls.forEach(node => {
      node.textContent = Shopify.formatMoney(
        this.currentVariant.compare_at_price + totalPrice,
        theme.money_format
      ).replace(/<[^>]+>/g, '');
    });


    priceEls.forEach((priceEl) => {
      priceEl.outerHTML = Shopify.formatMoney(this.currentVariant.price + totalPrice, theme.money_format);
    });

    compareAtPriceEls.forEach((compareAtPriceEl) => {
      compareAtPriceEl.outerHTML = Shopify.formatMoney(
        this.currentVariant.compare_at_price + totalPrice,
        theme.money_format
      );
    });

    stickyPriceEls.forEach((priceEl) => {
      priceEl.innerHTML = Shopify.formatMoney(this.currentVariant.price + totalPrice, theme.money_format);
    });

    stickyCompareAtPriceEls.forEach((compareAtPriceEl) => {
      compareAtPriceEl.innerHTML = Shopify.formatMoney(
        this.currentVariant.compare_at_price + totalPrice,
        theme.money_format
      );
    });

    if (this.discountLabel) {
      this.discountLabel.innerHTML = Shopify.formatMoney(
        this.currentVariant.price * ((100 - this.discountLabel.dataset.percentage) / 100) + totalPrice,
        theme.money_format
      );
    }
  }

  addCheckboxListener() {
    this.addEventListener('change', (e) => {
      if (e.target.classList.contains('product-add__checkbox')) {
        this.updateTotalPrice();
        if (this.maxCount) {
          this.changeProgressbar(e.target.checked);
        }
      } else if (e.target.classList.contains('product-add__quantity-input')) {
        this.onQuantityChange(e);
      }
    });
  }
}
customElements.define('product-accessories', ProductAccessories);
